const sw = {
  // Greetings & Date
  goodMorning: 'Habari za Asubuhi',
  goodAfternoon: 'Habari za Mchana',
  goodEvening: 'Habari za Jioni',
  dayNames: ['Jumapili', 'Jumatatu', 'Jumanne', 'Jumatano', 'Alhamisi', 'Ijumaa', 'Jumamosi'],
  monthNames: ['Januari', 'Februari', 'Machi', 'Aprili', 'Mei', 'Juni', 'Julai', 'Agosti', 'Septemba', 'Oktoba', 'Novemba', 'Desemba'],

  // Navigation
  dashboard: 'Dashbodi',
  sales: 'Mauzo',
  purchases: 'Manunuzi',
  expenses: 'Matumizi',
  inventory: 'Stock',
  setup: 'Tarifa za Biashara',
  settings: 'Mipangilio',

  // Common actions
  save: 'Hifadhi',
  cancel: 'Ghairi',
  edit: 'Hariri',
  delete: 'Futa',
  confirmDelete: 'Una uhakika unataka kufuta rekodi hii?',
  back: 'Rudi',
  add: 'Ongeza',
  close: 'Funga',
  customer: 'Mteja',
  supplier: 'Msambazaji',
  amount: 'Kiasi',
  actions: 'Vitendo',
  category: 'Aina',
  product: 'Bidhaa',
  qty: 'Idadi',
  description: 'Maelezo',
  balance: 'Salio',
  type: 'Aina',
  reference: 'Rejeleo',


  // Ribbon
  welcome: 'Karibu!',
  setBusinessName: 'Weka jina la biashara yako',
  autoCalculatedEditable: 'inahesabiwa moja kwa moja, inaweza kuhaririwa',

  // Settings screen
  businessName: 'Jina la Biashara',
  yourBusinessName: 'Jina lako la biashara',
  language: 'Lugha',
  english: 'English',
  swahili: 'Kiswahili',
  currency: 'Sarafu',
  darkMode: 'Hali ya Giza',
  darkModeSub: 'Badilisha mandhari ya giza (UI pekee)',
  fontSize: 'Ukubwa wa Herufi',
  small: 'Ndogo',
  medium: 'Wastani',
  large: 'Kubwa',
  appVersion: 'Toleo la App',

  // Dashboard
  businessOverview: 'Muhtasari wa Biashara',
  today: 'Leo',
  week: 'Wiki',
  month: 'Mwezi',
  year: 'Mwaka',
  thisWeek: 'Wiki',
  thisMonth: 'Mwezi',
  thisYear: 'Mwaka',
  revenue: 'Mapato',
  profit: 'Faida',
  loss: 'Hasara',
  totalSales: 'Jumla ya Mauzo',
  totalExpenses: 'Jumla ya Matumizi',
  totalPurchases: 'Jumla ya Manunuzi',
  productPurchases: 'Manunuzi ya Bidhaa (Stock)',
  productRevenue: 'Mapato ya Bidhaa',
  topProducts: 'Bidhaa Bora 3',
  insights: 'Maoni',
  recentActivity: 'Miamala ya hivi karibuni',
  noSalesRecordedYet: 'Hakuna mauzo yaliyorekodiwa bado',
  noActivityRecordedYet: 'Hakuna shughuli zilizorekodiwa bado',
  stockStatus: 'Hali ya Stock',
  itemsInStock: 'Bidhaa Zilizopo',
  lowStock: 'Bidhaa ambazo idaadi yake iko chini',

  // Sales
  salesSummary: 'Muhtasari wa Mauzo',
  recordNewSale: 'Rekodi Mauzo Mapya',
  viewDetailedSalesReport: 'Ripoti ya Kina',
  detailedSalesReport: 'Ripoti ya Mauzo ya Kina',
  totalRevenue: 'Jumla ya Mapato',
  totalItemsSold: 'Jumla ya Bidhaa Zilizouzwa',
  salesPerProduct: 'Mauzo kwa Bidhaa',
  salesList: 'Orodha ya Mauzo',
  selectProduct: 'Chagua Bidhaa',
  selectCustomer: 'Chagua Mteja',
  productName: 'Jina la Bidhaa',
  quantity: 'Idadi',
  sellingPrice: 'Bei ya Kuuza',
  customerName: 'Jina la Mteja',
  date: 'Tarehe',
  totalCost: 'Gharama ya Jumla',
  pleaseRegisterProducts: 'Tafadhali sajili bidhaa kwenye Mpangilio kwanza',

  // Purchases
  purchasesSummary: 'Muhtasari wa Manunuzi',
  registerPurchase: 'Sajili Ununuzi Mpya',
  recordingSection: 'Kanda ya Kurekodi',
  purchasesReports: 'Ripoti za Manunuzi',
  viewDetailedReport: 'Ripoti ya Kina',
  detailedPurchaseReport: 'Ripoti ya Manunuzi ya Kina',
  fromDate: 'Kuanzia Tarehe',
  toDate: 'Mpaka Tarehe',
  totalSpend: 'Jumla ya Gharama',
  totalItems: 'Jumla ya Bidhaa',
  purchasesList: 'Orodha ya Manunuzi',
  totalCostPerProduct: 'Jumla ya Gharama kwa Bidhaa',
  unitPrice: 'Bei ya Kimoja',
  downloadPDF: 'Pakua Ripoti ya PDF',
  downloadExcel: 'Pakua Excel',
  downloadCSV: 'Pakua CSV',

  // Expenses
  expensesSummary: 'Muhtasari wa Matumizi',
  recordNewExpense: 'Rekodi Matumizi Mapya',
  viewDetailedExpensesReport: 'Ripoti ya Kina',
  detailedExpensesReport: 'Ripoti ya Matumizi ya Kina',
  expenseName: 'Jina la Matumizi',
  totalExpense: 'Jumla ya Matumizi',
  expensesPerCategory: 'Matumizi kwa Aina',
  expensesList: 'Orodha ya Matumizi',
  selectCategory: 'Chagua Aina ya Matumizi',

  // Stock / Inventory
  stockLevels: 'Viwango vya Stock',
  currentStock: 'Idadi Iliyopo Sasa',
  openingStock: 'Idadi Iliyokuwepo Mwanzo',
  stockIn: 'Stock Iliyoingia',
  stockOut: 'Stock Iliyotoka',
  openingStockQty: 'Idadi ya Mwanzo',
  openingStockValue: 'Thamani ya Stock ya Mwanzo',
  minStockAlert: 'Tahadhari ya Kiwango cha Chini',
  stockAlertLevel: 'Kiwango cha Chini cha Tahadhari',
  quantityInStock: 'Idadi ya Stock',
  totalStockValue: 'Jumla ya Thamani ya Stock (TSh)',
  lowStockThreshold: 'Kiwango cha Chini cha Stock',
  addNewStock: 'Ingiza Stock Mpya',
  stockChart: 'Chati ya Stock',
  healthChart: 'Chati ya Afya ya Stock',
  healthyProducts: 'Bidhaa Zenye Afya',
  lowStockProducts: 'Bidhaa ambazo idaadi yake iko chini',
  totalProducts: 'Jumla ya Bidhaa',
  topLowStock: 'Bidhaa 10 ambazo idaadi yake iko chini zaidi',
  stockAlerts: 'Bidhaa Zinazohitaji Kuongezwa',
  allStockGood: 'Bidhaa zote zipo katika hali nzuri',
  currentStockLevel: 'Kiwango cha Stock cha Sasa',

  // Setup
  products: 'Bidhaa',
  expenseCategories: 'Majina ya Matumizi',
  suppliers: 'Wauzaji/Wasambazaji',
  productList: 'Orodha ya Bidhaa Zilizosajiliwa',
  expenseList: 'Orodha ya Aina za Matumizi',
  registerNewProduct: 'Sajili Bidhaa Mpya',
  registerExpenseType: 'Sajili Aina ya Matumizi',
  productRegistration: 'Usajili wa Bidhaa',
  expenseRegistration: 'Usajili wa Matumizi',
  price: 'Bei',
  cost: 'Gharama',
  noProductsYet: 'Hakuna bidhaa zilizosajiliwa bado. Sajili bidhaa yako ya kwanza hapo juu.',
  noExpenseCategoriesYet: 'Hakuna aina za matumizi zilizosajiliwa bado.',
  noSuppliersYet: 'Hakuna wauzaji/wasambazaji waliowekwa bado.',
  supplierName: 'Jina la Msambazaji',
  contactOptional: 'Mawasiliano (hiari)',
  phoneOrEmail: 'Simu au barua pepe',
  addSupplier: 'Sajili Msambazaji',
  editSupplier: 'Hariri Msambazaji',
  addCategory: 'Sajili Aina',
  addProduct: 'Sajili Bidhaa',
  expenseType: 'Aina ya Gharama',
  expenseCategoryPlaceholder: 'mf. Kodi, Usafiri, Mishahara',

  // Sales screen
  newSale: 'Rekodi Mauzo',
  sell: 'Uza',
  salesReports: 'Ripoti za Mauzo',
  unitsSold: 'Idadi ya Bidhaa Zilizouzwa',
  salesCount: 'Idadi ya Miamala',
  salesByProduct: 'Mauzo kwa Bidhaa',
  topSellingProducts: 'Bidhaa Zinazotoka (Uzwa) Zaidi',
  lowSellingProducts: 'Bidhaa Zinazouzwa Kidogo',
  units: 'vipande',
  recentSales: 'Mauzo ya Hivi Karibuni',
  clientsServed: 'Idadi ya Wateja Waliohudumiwa',
  avgPerJob: 'Wastani / Kazi',
  incomeByService: 'Mapato ya Kila Huduma',
  topServices: 'Huduma Bora',
  byRevenue: 'Kwa Mapato',
  byProfit: 'Kwa Faida',
  recordServicesToSeeRankings: 'Rekodi huduma kuona orodha',
  clientInsights: 'Maarifa ya Wateja',
  whoComesBackMost: 'Wanaokuja mara kwa mara & wanachopenda',
  startTrackingClients: 'Anza kufuatilia wateja wako',
  startTrackingClientsDesc: 'Unaporekodia huduma, ongeza jina la mteja. Sehemu hii itakuonyesha anayekuja mara nyingi, anatumia kiasi gani, na huduma anazopenda.',
  visitSingular: 'ziara',
  visitPlural: 'ziara',
  prefers: 'anapenda',
  repeatClient: 'Mteja wa Kawaida',
  invoiceManagement: 'Uratibu wa Invoisi',
  invoiceManagementProducts: 'Invoisi',
  invoiceManagementServices: 'Invoisi',
  listProformaInvoices: 'Orodha za Proforma Invoisi',
  listIssuedInvoices: 'Orodha za Invoisi Zilizotolewa',
  proformaInvoices: 'Proforma Invoisi',
  issuedInvoices: 'Invoisi Zilizotolewa',
  noProformaInvoices: 'Hakuna proforma invoisi bado',
  noIssuedInvoices: 'Hakuna invoisi zilizotolewa bado',
  invoices: 'invoisi',


  // Purchases screen
  addPurchase: 'Rekodi Manunuzi',
  purchaseReports: 'Ripoti za Manunuzi',
  itemsBought: 'Bidhaa Zilizununuliwa',
  orders: 'Maagizo',
  purchasesCount: 'Idadi ya Miamala',
  purchasesByProduct: 'Manunuzi kwa Bidhaa',
  supplierBreakdown: 'Muhtasari wa Wauzaji/Wasambazaji',
  highCostItems: 'Bidhaa za Gharama Kubwa',
  recentPurchases: 'Manunuzi ya Hivi Karibuni',

  // Expenses screen
  addExpense: 'Rekodi Matumizi',
  expenseReports: 'Ripoti za Matumizi',
  expenseTitle: 'Kichwa cha matumizi',
  notesOptional: 'Maelezo (hiari)',
  noOfExpenses: 'rekodi za matumizi',
  expensesByCategory: 'Matumizi kwa Aina',
  biggestExpenses: 'Matumizi Makubwa Zaidi',
  recentExpenses: 'Matumizi ya Hivi Karibuni',

  // Stock screen
  stockOverview: 'Muhtasari wa Stock',
  items: 'bidhaa',
  addedThisWeek: 'Iliongezwa Wiki Hii',
  soldThisWeek: 'Iliuzwa Wiki Hii',
  minLabel: 'Kiwango',
  leftLabel: 'zilizobaki',
  inStock: 'Inapatikana',
  stockLow: 'Stoo Ndogo',
  fastMovingItems: 'Bidhaa Zinazoenda Haraka',
  topPerforming: 'Bidhaa Zinazofanya Vizuri',
  unitCost: 'Gharama kwa Kipande',
  productHistory: 'Historia ya Bidhaa',
  noHistoryAvailable: 'Hakuna historia inayopatikana',
  totalPurchased: 'Jumla Iliyonunuliwa',
  totalSold: 'Jumla Iliyouzwa',
  inLabel: 'Ndani',
  outLabel: 'Nje',
  soldLabel: 'zilizouzwa',


  // Setup form labels
  editProduct: 'Hariri Bidhaa',
  editCategory: 'Hariri Aina',
  addExpenseCategory: 'Sajili Aina ya Matumizi',
  categoryName: 'Jina la Aina',
  noContactInfo: 'Hakuna mawasiliano',
  priceOptional: 'Bei (hiari)',
  costOptional: 'Gharama (hiari)',
  totalValue: 'Jumla ya Thamani',
  valueLabel: 'Thamani',
  alertLabel: 'Tahadhari',

  // Reports shared
  startDate: 'Tarehe ya Kuanza',
  endDate: 'Tarehe ya Kumalizika',
  noDataForPeriod: 'Hakuna data kwa kipindi kilichochaguliwa',
  titleLabel: 'Kichwa',

  pleaseAddExpenseCategories: 'Tafadhali sajili aina za matumizi kwenye Mpangilio',

  // Purchase / Supplier type
  supplierType: 'Muuzaji (Hiari)',
  registeredSupplier: 'Jina Limesajiliwa',
  otherSupplier: 'Halijasajiliwa',
  enterSupplierName: 'Weka jina la muuzaji',
  purchaseCost: 'Gharama ya Ununuzi (TSh)',
  costPerSale: 'Gharama / Gharama ya Ununuzi',
  profitPerSale: 'Faida',

  // Customers
  customers: 'Wateja',
  addCustomer: 'Sajili Mteja',
  editCustomer: 'Hariri Mteja',
  noCustomersYet: 'Hakuna wateja waliosajiwa bado.',
  phoneOptional: 'Simu (hiari)',
  customerType: 'Aina ya Mteja',
  walkIn: 'Mgeni',
  registered: 'Aliyesajiliwa',
  enterCustomerName: 'Andika jina la mteja',

  // Payment
  paymentMethod: 'Njia ya Malipo',
  cash: 'Taslimu',
  bank: 'Benki',
  mobile: 'Simu',
  mobileMoney: 'Wakala/Simu',
  credit: 'Mkopo',
  paymentStatus: 'Hali ya Malipo',
  paid: 'Imelipwa',
  unpaid: 'Haijalipiwa (Mkopo)',

  // Reports filters
  filterByProduct: 'Chuja kwa Bidhaa',
  filterByPayment: 'Chuja kwa Malipo',
  filterByCustomer: 'Chuja kwa Mteja',
  allProducts: 'Bidhaa Zote',
  allPayments: 'Malipo Yote',
  allCustomers: 'Wateja Wote',
  creditSales: 'Deni la Wateja',

  // Debt / Loan payment
  receiveDebtPayment: 'Pokea Malipo ya Deni',
  payLoan: 'Lipa Mkopo',
  selectDebt: 'Chagua Deni Linalodaiwa',
  selectLoan: 'Chagua Mkopo Unaodaiwa',
  markAsPaid: 'Weka Alama ya Kulipwa',
  debtPaymentSuccess: 'Malipo yamerekodiwa',

  // Expenses tab UI (updated)
  recordExpense: 'Rekodi Gharama',
  viewExpenseReports: 'Tazama Ripoti za Gharama',
  expenseTrend: 'Mwelekeo wa Gharama',

  // Purchases tab UI (updated)
  recordPurchase: 'Rekodi Manunuzi',
  viewPurchasesReports: 'Tazama Ripoti za Manunuzi',
  purchaseTrend: 'Mwelekeo wa Manunuzi',
  topPurchasedProducts: 'Bidhaa Zilizounuliwa Zaidi',
  lowPurchasedProducts: 'Bidhaa Zilizounuliwa Kidogo',

  // Sales tab UI (updated)
  recordSale: 'Rekodi Mauzo',
  viewSalesReports: 'Ripoti za Mauzo',
  custom: 'Chagua',
  annualPerformance: 'Utendaji wa Mwaka',
  salesTrend: 'Mwelekeo wa Mauzo',
  productPerformance: 'Utendaji wa Bidhaa',
  salesOverview: 'Muhtasari wa Mauzo',
  salesOverviewSub: 'Sales Overview',
  annualPerformanceSub: 'Annual Performance',
  selectYear: 'Chagua Mwaka',
  annualTotal: 'Jumla ya Mwaka',
  overallProductPerformance: 'Utendaji wa Mwaka wa Bidhaa Zote',
  overallProductSub: 'Mapato kwa bidhaa zote',
  lowestSellersRevenue: 'Bidhaa 5 za Mapato Madogo',
  lowestSellersRevenueSub: 'Bidhaa zenye mapato madogo mwaka huu',

  // Misc
  comingSoon: 'Inakuja Hivi Karibuni',
  status: 'Hali',
  costPerItem: 'Gharama kwa Kitu',

  // Account Balances (Dashboard)
  accountBalances: 'Salio la Akaunti',
  tapToView: 'Gusa kuona',

  // Dashboard section headers
  businessSummary: 'Muhtasari wa Biashara',
  accrualBasis: 'Mauzo yote (yaliyolipwa + mkopo)',
  cashPosition: 'Mtiririko wa Ki-Fedha',
  cashPositionNote: 'Pesa halisi tu',
  debts: 'Madeni',
  netCashflow: 'Jumla',
  paidLabel: 'Imelipwa',
  creditLabel: 'Mkopo',
  unpaidLabel: 'Haijalipwa',

  // Debts Overview (Dashboard)
  debtsOverview: 'Muhtasari wa Madeni',
  receivablesLabel: 'Madeni ya Wateja',
  payablesLabel: 'Madeni kwa Wauzaji',
  customersOweYou: 'Wateja wanakudai',
  youOweSuppliers: 'Unadaiwa na wauzaji',
  outstandingCustomerDebts: 'Madeni ya Wateja Yanayosubiri',
  outstandingSupplierDebts: 'Madeni kwa Wauzaji Yanayosubiri',
  moreItems: 'zaidi',

  // Drilldown screens
  salesDetails: 'Maelezo ya Mauzo',
  purchaseDetails: 'Maelezo ya Manunuzi',
  expenseDetails: 'Maelezo ya Matumizi',
  cashAccountTitle: 'Pesa Taslimu',
  bankAccountTitle: 'Benki',
  mobileMoneyAccountTitle: 'Pesa iliyoko kwenye simu (Mitandao)',
  openingBalance: 'Salio la Mwanzo',
  closingBalance: 'Salio la Mwisho',
  noRecordsFound: 'Hakuna kumbukumbu kwa kipindi hiki',
  recordsLabel: 'kumbukumbu',
  moneyIn: 'Ndani',
  moneyOut: 'Nje',

  // Business Profile & Payment Settings
  businessProfile: 'Wasifu wa Biashara',
  businessAddress: 'Anwani ya Biashara',
  businessAddressPlaceholder: 'Mtaa, Mji, Nchi',
  businessLogo: 'Nembo ya Biashara',
  uploadLogo: 'Bonyeza kupakia nembo',
  removeLogo: 'Ondoa',
  logoUploaded: 'Nembo imepakiwa',
  bankDetails: 'Maelezo ya Benki',
  bankName: 'Jina la Benki',
  accountName: 'Jina la Akaunti',
  accountNumber: 'Namba ya Akaunti',
  mobileMoneyProvider: 'Mtoa Huduma (mfano M-Pesa)',
  mobileMoneyNumber: 'Namba ya Pesa iliyoko kwenye simu',
  paymentDetails: 'Maelezo ya Malipo',
  phone: 'Simu',

  // Authentication
  login: 'Ingia',
  signup: 'Jisajili',
  logout: 'Toka',
  email: 'Barua pepe',
  emailOrPhone: 'Barua Pepe au Simu',
  password: 'Nywila',
  fullName: 'Jina Kamili',
  forgotPassword: 'Umesahau Nenosiri?',
  resetPassword: 'Weka Upya Nenosiri',
  agreeToTerms: 'Tafadhali kubali Masharti & Sera ya Faragha kuendelea.',
  termsPrivacy: 'Masharti & Faragha',
  termsAndPrivacy: 'Masharti & Sera ya Faragha',
  iAgreeToThe: 'Nakubali',
  agreeAndContinue: 'Kubali & Endelea',
  loginToYourAccount: 'Ingia kwenye akaunti yako',
  signupToGetStarted: 'Unda akaunti kuanza',
  ownerName: 'Jina la mmiliki',
  confirmPassword: 'Thibitisha nywila',
  alreadyHaveAccount: 'Je, tayari una akaunti?',
  dontHaveAccount: 'Huna akaunti?',
  loginSuccess: 'Umeingia kwa mafanikio',
  signupSuccess: 'Akaunti imeundwa kwa mafanikio',
  loginError: 'Imeshindwa kuingia. Tafadhali angalia taarifa zako.',
  signupError: 'Imeshindwa kujisajili. Tafadhali jaribu tena.',
  resetEmailSent: 'Kiungo cha kubadilisha nywila kimetumwa kwenye barua pepe yako!',
  userNotFound: 'Hakuna akaunti iliyopatikana na barua pepe hii.',
  passwordMismatch: 'Nywila hazilingani',
  passwordTooShort: 'Nywila lazima iwe na angalau herufi 8',
  invalidEmail: 'Tafadhali andika barua pepe halali',
  welcomeBack: 'Karibu tena',
  createAccount: 'Tengeneza Akaunti',
  enterEmail: 'Andika barua pepe yako',
  enterPassword: 'Andika nywila yako',
  enterBusinessName: 'Andika jina la biashara',
  enterOwnerName: 'Andika jina lako',
  professionalBusiness: 'Biashara ya Kitaalamu',
  hi: 'Habari !',
  rememberMe: 'Nikumbuke',
  createLabel: 'Tengeneza',
  newAccount: 'Akaunti Mpya',
  forgotPasswordTitle: 'Umesahau',
  passwordLabel: 'Nywila',
  send: 'TUMA',
  setNew: 'Weka Mpya',
  newPassword: 'Nywila Mpya',
  confirmNewPassword: 'Thibitisha Nywila Mpya',
  resetEmailSentDesc: 'Andika nywila yako mpya hapa chini kubadilisha akaunti yako.',
  passwordResetSuccess: 'Nywila imebadilishwa kwa mafanikio! Tafadhali ingia.',
  passwordTooShort: 'Nywila lazima iwe na herufi 6 au zaidi.',
  resetError: 'Imeshindwa kubadilisha nywila. Tafadhali jaribu tena.',
  // Appearance / themes
  appearance: 'Mwonekano',
  appearanceSub: 'Chagua jinsi programu inavyoonekana.',
  themeVibrant: 'Mwangavu',
  themeBold: 'Imara',
  themeMinimal: 'Sahili',
  themeDark: 'Giza',
  // Hero-split auth screens
  appTagline: 'Endesha biashara yako kwa busara. Ankara, hesabu ya bidhaa, na ripoti mahali pamoja.',
  welcomeHeroLine: 'Karibu',
  welcomeHeroAccent: 'tena.',
  signInEyebrow: 'Ingia',
  hiThere: 'Habari,',
  loginSub: 'Weka taarifa zako kuendelea.',
  emailPh: 'wewe@mfano.com',
  fullNamePh: 'Jina lako kamili',
  signupHeroLine: 'Fungua',
  signupHeroAccent: 'akaunti.',
  signupEyebrow: 'Jisajili',
  signupTitle: 'Hebu tukuanzishie',
  signupSub: 'Taarifa chache tu kufungua akaunti yako.',
  forgotHeroLine: 'Umesahau',
  forgotHeroAccent: 'nywila?',
  forgotHeroSub: 'Weka barua pepe uliyotumia kujisajili na tutakutumia kiungo salama cha kubadilisha.',
  resetEyebrow: 'Badilisha',
  forgotTitle: 'Angalia barua pepe yako',
  forgotSub: 'Tutakutumia kiungo cha kuweka nywila mpya.',
  setNewHeroLine: 'Weka nywila',
  setNewHeroAccent: 'mpya.',
  setNewHeroSub: 'Chagua nywila imara kulinda akaunti yako.',
  almostDone: 'Karibu umemaliza',
  samePasswordError: 'Nywila yako mpya lazima iwe tofauti na nywila yako ya sasa. Tafadhali chagua nywila tofauti.',
  weakPasswordError: 'Nywila hii ni dhaifu. Tumia angalau herufi 6 zenye mchanganyiko wa herufi na nambari.',
  resetLinkExpired: 'Kiungo hiki cha kubadilisha nywila kimekwisha muda wake. Tafadhali omba kingine kutoka ukurasa wa Umesahau Nywila.',
  resetLinkInvalid: 'Kiungo hiki cha kubadilisha nywila si halali au kimetumika tayari. Tafadhali omba kingine.',
  rememberYourPassword: 'Unakumbuka nywila yako?',
  mockEmailFrom: 'Biashara Track APP',
  mockEmailSubject: 'Ombi la Kubadilisha Nywila',
  mockEmailBody: 'Umeomba kubadilisha nywila ya akaunti yako ya Biashara Track APP. Bonyeza kitufe hapa chini kuweka nywila mpya.',
  mockEmailResetBtn: 'Badilisha Nywila Yangu',
  dismissLabel: 'Ondoa',

  // Subscription
  subscription: 'Usajili',
  choosePlan: 'Chagua Mpango Wako',
  monthly: 'Kila mwezi',
  yearly: 'Kila mwaka',
  monthlyPrice: '$9.99/kila mwezi',
  yearlyPrice: '$99/kila mwaka',
  yearlySavings: 'Okoa 17%',
  subscribe: 'Jisajili',
  currentPlan: 'Mpango wa sasa',
  subscriptionRequired: 'Usajili Unahitajika',
  subscriptionMessage: 'Chagua mpango wa usajili kuendelea kutumia programu',
  freeTrial: 'Jaribio la bure la siku 7',
  cancelAnytime: 'Acha wakati wowote',
  allFeatures: 'Vipengele vyote vinajumuishwa',
  prioritySupport: 'Msaada wa kipaumbele',
  unlimitedData: 'Hifadhi ya data isiyo na kikomo',

  // Proforma Invoice
  proformaInvoice: 'Proforma Invoisi',
  generateProforma: 'Tengeneza Proforma Invoisi',
  proformaTitle: 'PROFORMA INVOISI',
  addItem: 'Ongeza Bidhaa',
  removeItem: 'Ondoa',
  lineTotal: 'Jumla',
  subtotal: 'Jumla Ndogo',
  discount: 'Punguzo (%)',
  discountAmount: 'Punguzo',
  grandTotal: 'Jumla Kuu',
  notATaxInvoice: 'Hii proforma invoisi tu \u2014 si tax invoice.',
  validFor: 'Inatumika kwa siku 30 kutoka tarehe ya kutolewa.',
  proformaNo: 'Namba ya Proforma',
  downloadProforma: 'Pakua Proforma (PDF)',
  customerDetails: 'Taarifa za Mteja',
  itemRequired: 'Tafadhali sajili bidhaa angalau moja yenye jina la bidhaa, kiasi na bei.',

  // Backup & Restore
  backupRestore: 'Hifadhi na Urejesho wa Data',
  backupDesc: 'Hamisha data yako yote kwenye faili kwa usalama au kuhamisha kwa kifaa kingine.',
  exportData: 'Hamisha Data (Nakala Rudufu)',
  importData: 'Ingiza Data (Urejesho)',
  importWarning: 'Kuingiza kutabadilisha data YOTE ya sasa. Hii haiwezi kutendwa.',
  importSuccess: 'Data imerejeshwa! Programu itaanza upya.',
  importError: 'Faili batili. Tafadhali chagua faili sahihi ya Biashara Track.',

  // Invoice
  generateInvoice: 'Tengeneza Ankara',
  invoiceNo: 'Namba ya Invoisi',
  billTo: 'Lipia Kwa',
  saleRecorded: 'Mauzo Yamehifadhiwa!',
  invoiceReady: 'Mauzo yamehifadhiwa. Tengeneza invoisi kwa mteja wako.',
  downloadInvoice: 'Pakua Invoisi (PDF)',
  done: 'Imekamilika',
  viewInvoice: 'Invoisi',

  // Manual transaction / Withdrawal form
  updateBalanceWithdraw: 'Sasisha Salio / Toa Pesa',
  manualTransaction: 'Muamala wa Mkono',
  transactionTypeLabel: 'Aina ya Muamala',
  withdrawOption: 'Toa (Pesa Nje)',
  depositOption: 'Weka (Pesa Ndani)',
  enterAmountPlaceholder: 'Weka kiasi',
  withdrawalDescPlaceholder: 'mf. Kutoa kwa matumizi binafsi',
  saveTransaction: 'Hifadhi Muamala',

  // Setup menu
  notSet: 'Haijawekwa',
  noItemsYet: 'Hakuna vitu bado',
  addNew: 'Sajili Kipya',
  productServices: 'Bidhaa / Huduma',
  services: 'Huduma',
  service: 'Huduma',
  itemType: 'Aina ya Kipengee',
  selectService: 'Chagua Huduma',
  serviceName: 'Jina la Huduma',
  addService: 'Sajili Huduma',
  editService: 'Hariri Huduma',
  defaultPrice: 'Bei ya Kawaida',
  recordService: 'Rekodi Huduma',
  serviceTransactions: 'Muamala wa Huduma',
  serviceRevenue: 'Mapato ya Huduma',
  serviceProfit: 'Faida ya Huduma',
  defaultCost: 'Gharama ya Kawaida',
  optional: 'hiari',
  pleaseRegisterServices: 'Tafadhali sajili huduma kwanza katika Mipangilio',
  businessType: 'Aina ya Biashara',
  selectBusinessType: 'Chagua aina ya biashara yako',
  serviceOnly: 'Huduma Tu',
  productsOnly: 'Bidhaa Tu',
  productsAndServices: 'Bidhaa na Huduma',
  serviceOnlyDesc: 'Unatoa huduma (ushauri, ukarabati, n.k.)',
  productsOnlyDesc: 'Unauza bidhaa za kimwili au za kidijitali',
  productsAndServicesDesc: 'Unauza bidhaa na kutoa huduma',
  paymentAccounts: 'Akaunti za Malipo',
  addPaymentAccount: 'Ongeza Akaunti',
  editPaymentAccount: 'Hariri Akaunti',
  noPaymentAccountsYet: 'Hakuna akaunti za malipo bado',
  bankAccount: 'Akaunti ya Benki',
  mobileMoneyAccount: 'Mtandao wa Simu/Wakala',
  accountType: 'Aina ya Akaunti',
  networkName: 'Mtoa Huduma (mfano M-Pesa)',
  phoneNumberLabel: 'Namba ya Simu/Wakala',

  // Hardcoded string keys (Setup subtitles, placeholders, contact labels)
  startHere: 'Tarifa za Biashara',
  businessNameSub: 'Jina hili linaonekana kwenye invoisi na ripoti zako.',
  businessAddressSub: 'Inaonyeshwa kwenye invoisi chini ya jina la biashara yako.',
  bankNamePlaceholder: 'mf. CRDB, NMB, Equity',
  accountHolderPlaceholder: 'Jina la mmiliki wa akaunti',
  accountNumberPlaceholder: 'Namba ya akaunti',
  networkNamePlaceholder: 'mf. M-Pesa, Tigo Pesa, Airtel',
  phonePlaceholder: 'mf. 0712 345 678',
  contactEmailLabel: 'Barua pepe',
  contactPhoneLabel: 'Simu',
  contactWebsiteLabel: 'Tovuti',
  itemSingular: 'kitu',
  itemPlural: 'vitu',
  accountSingular: 'akaunti',
  accountPlural: 'akaunti',
  accountNameRequired: 'Jina la akaunti linahitajika',
  bankNameRequired: 'Jina la benki linahitajika',
  networkNameRequired: 'Jina la mtandao linahitajika',

  // Currency setup
  chooseCurrency: 'Chagua Sarafu',
  currencySubLabel: 'Inatumika kwenye ripoti na invoisi zote',

  // Compliance & Tax section
  complianceTax: 'Uzingatiaji na Kodi',
  complianceTaxDesc: 'Maelezo haya yanaonekana kwenye invoisi na risiti zako kwa uzingatiaji wa kisheria.',
  tinLabel: 'TIN (Nambari ya Utambulisho wa Kodi)',
  vrnLabel: 'VRN (Nambari ya Usajili wa VAT)',
  businessRegLabel: 'Nambari ya Usajili wa Biashara',
  tradeLicenseLabel: 'Nambari ya Leseni ya Biashara',
  complianceOptionalNote: 'Sehemu hizi si lazima. Jaza kama biashara yako imesajiliwa na TRA au ina leseni ya biashara.',

  // Settings screen
  subscriptionStatus: 'Hali ya Usajili',
  activePlan: 'Inafanya Kazi',
  expiredLabel: 'Imeisha',
  expiresOn: 'Inaisha',
  trialPlan: 'Jaribio la Bure',
  planMonthly: 'Mpango wa Kila Mwezi',
  planYearly: 'Mpango wa Kila Mwaka',
  choosePlanTitle: 'Chagua Mpango Wako',
  selectThisPlan: 'Chagua Mpango',
  popular: 'MAARUFU',
  currentPlanBadge: 'Sasa Hivi',
  perMonth: '/mwezi',
  freeTrialDesc: 'Jaribio la siku 7 la bure kuchunguza vipengele vyote',
  fkStarter: 'FK Starter',
  fkStarterPrice: 'TZS 10,000',
  fkStarterDuration: 'Mwezi 1',
  fkPlus: 'FK Plus',
  fkPlusPrice: 'TZS 28,000',
  fkPlusDuration: 'Miezi 3',
  fkSmart: 'FK Smart',
  fkSmartPrice: 'TZS 50,000',
  fkSmartDuration: 'Miezi 6',
  fkPremium: 'FK Premium',
  fkPremiumPrice: 'TZS 90,000',
  fkPremiumDuration: 'Miezi 12',
  privacyPolicy: 'Sera ya Faragha',
  contactUs: 'Wasiliana Nasi',
  sessionExpiredTitle: 'Kipindi Kimeisha',
  sessionExpiredDesc: 'Kipindi chako kimeisha. Tafadhali ingia tena ili kuendelea kusawazisha data yako. Data yako ya ndani iko salama.',
  logInAgain: 'Ingia Tena',
  exportAllData: 'Hamisha Data Yote',
  exportAllDataDesc: 'Pakua kama Excel (.xlsx)',
  synced: 'Imesawazishwa',
  syncing: 'Inasawazisha…',
  offline: 'Nje ya Mtandao',
  offlineMode: 'Nje ya mtandao — data imehifadhiwa',
  deleteAccount: 'Futa Akaunti',
  deleteAccountWarning: 'Hii itafuta kabisa akaunti yako na data yako yote ya biashara kutoka kwa wingu. Hatua hii haiwezi kutenduliwa.',
  deleteAccountNote: 'Data yako itafutwa ndani ya siku 30 kulingana na Sera yetu ya Faragha.',
  typeDeleteToConfirm: 'Andika FUTA kuthibitisha:',
  deleting: 'Inafuta…',
  contactEmail: 'hesabusolutionstz@gmail.com',
  contactPhone: '+255 680072640',
  contactWebsite: 'www.faidaapp.com',
  privacyPolicyText: 'Imesasishwa: Mei 2025\n\nBiashara Track ("sisi", "yetu") inamilikiwa na Hesabu Solutions. Sera hii ya Faragha inaeleza jinsi tunavyokusanya, kutumia, kuhifadhi, na kulinda taarifa zako unapotumia programu ya Biashara Track.\n\n1. TAARIFA TUNAZOKUSANYA\nTunakusanya: barua pepe yako na jina la biashara (wakati wa usajili); data ya biashara unayoingiza (mauzo, manunuzi, gharama, bidhaa, wateja, wasambazaji); na taarifa za msingi za kifaa kwa uboreshaji wa programu.\n\n2. JINSI DATA YAKO INAVYOHIFADHIWA\nData yako huhifadhiwa katika maeneo mawili: (a) kwenye kifaa chako (hifadhi ya ndani) kwa matumizi bila mtandao na utendaji wa haraka, na (b) kwenye seva salama za wingu zinazotolewa na Supabase (supabase.com), jukwaa la hifadhidata ya wingu. Usawazishaji wa wingu huhifadhi nakala ya data yako na kuipatikana kwenye vifaa vingi. Supabase huhifadhi data katika vituo salama vilivyosimbwa fiche.\n\n3. JINSI TUNAVYOTUMIA DATA YAKO\nTunatumia data yako: kutoa na kuendesha programu ya Biashara Track; kusawazisha data yako kwenye vifaa; kutuma arifa muhimu za akaunti na usajili; na kuboresha utendaji wa programu. Hatutumii data yako kwa madhumuni ya matangazo.\n\n4. HUDUMA ZA WAHUSIKA WENGINE\nTunatumia huduma zifuatazo za wahusika wengine:\n- Supabase (supabase.com): hifadhi salama ya data ya wingu na uthibitishaji wa watumiaji\n- ClickPesa: usindikaji wa malipo ya usajili\n\nWatoa huduma hawa wana sera zao za faragha na wanatakiwa kisheria kulinda data yako.\n\n5. KUSHIRIKI DATA\nHatuuzi, kukodisha, au kushiriki data yako ya kibinafsi au biashara na wahusika wengine kwa madhumuni ya kibiashara. Data inaweza kufunuliwa ikiwa inahitajika kisheria au kulinda usalama wa watumiaji.\n\n6. HAKI ZAKO\nUna haki ya: kufikia data tunayoshikilia kuhusu wewe; kusafirisha data yako yote ya biashara (inapatikana katika Mipangilio); kuomba kufutwa kwa akaunti yako na data zote zinazohusiana; na kusahihisha taarifa zisizo sahihi.\n\n7. UHIFADHI WA DATA\nData yako huhifadhiwa mradi akaunti yako ipo hai. Unapofuta akaunti yako, data yote ya wingu hufutwa kabisa ndani ya siku 30.\n\n8. USALAMA\nTunatumia usimbaji fiche wakati wa uhamishaji (HTTPS/TLS) na wakati wa kuhifadhi (Supabase AES-256). Hata hivyo, hakuna mfumo ulio salama kabisa — tafadhali weka siri za kuingia kwako salama.\n\n9. MAWASILIANO\nKwa maswali ya faragha au maombi ya data, wasiliana nasi: hesabusolutionstz@gmail.com',

  // Subscription Payment Flow
  daysLeft: 'siku zimebaki',
  subExpiredTitle: 'Usajili wako umeisha',
  subExpiredDesc: 'Fanya upya usajili wako ili kuendelea kutumia Biashara Track APP. Chagua mpango hapa chini kuanza.',
  upgradeOrRenew: 'Panda Daraja au Fanya Upya',
  payForPlan: 'Lipia',
  mobileMoneyPhone: 'Nambari ya Simu (Mobile Money)',
  invalidPhone: 'Weka nambari sahihi ya simu',
  payNow: 'Lipa Sasa',
  creatingPayment: 'Inaunda malipo...',
  waitingForPayment: 'Inasubiri malipo...',
  verifyingPayment: 'Inathibitisha malipo...',
  checkYourPhone: 'Angalia simu yako kwa ujumbe wa malipo',
  pleaseWait: 'Tafadhali subiri',
  paymentSuccess: 'Malipo Yamefanikiwa!',
  subscriptionActivated: 'Usajili wako umeamilishwa.',
  paymentFailed: 'Malipo Yameshindwa',
  tryAgain: 'Jaribu Tena',
  accessAllFeatures: 'Fikia vipengele vyote',

  // Quick Reports (Dashboard)
  quickReports: 'Ripoti za Haraka',
  customerStatement: 'Taarifa ya Mteja',
  agingReport: 'Ripoti ya Madeni',
  receivablesAgingReport: 'Ripoti ya Madeni ya Wateja',
  dailySummary: 'Muhtasari wa Siku',
  stockValuation: 'Tathmini ya Stock',
  whtReport: 'Ripoti ya WHT',
  whtReportFull: 'Ripoti ya WHT (Kodi ya Zuio)',

  // Customer Statement labels
  allCustomersOption: 'Wateja Wote',
  totalBilled: 'Jumla Iliyoombwa',
  totalPaid: 'Jumla Iliyolipwa',
  balanceOwed: 'Salio Linalodaiwa',
  noTransactionsFound: 'Hakuna miamala iliyopatikana',

  // Aging Report labels
  totalOutstanding: 'Jumla ya Madeni',
  acrossInvoices: 'invoisi',
  acrossInvoicesPlural: 'invoisi',
  noOutstandingInvoices: '★ Hakuna invoisi zilizo na deni!',

  // Daily Summary labels
  salesRevenue: 'Mapato ya Mauzo',
  grossProfit: 'Faida ya Msingi',
  transactionsLabel: 'Miamala',
  noTransactionsDate: 'Hakuna miamala kwa tarehe hii.',

  // Daily Summary transaction type badges
  saleLabel: 'Uzo',
  buyLabel: 'Nunu',
  expLabel: 'Mat',

  // Stock Valuation labels
  totalCostValue: 'Jumla ya Thamani ya Gharama',
  totalSellingValue: 'Jumla ya Thamani ya Kuuza',
  costPerUnit: 'Gharama/Kipande',
  sellPerUnit: 'Bei/Kipande',
  costValue: 'Thamani ya Gharama',
  sellValue: 'Thamani ya Kuuza',
  noProductsFound: 'Hakuna bidhaa zilizopatikana',

  // WHT Report labels
  totalWHTCollected: 'Jumla ya WHT Iliyokusanywa',
  noWHTTransactions: 'Hakuna miamala ya WHT katika kipindi hiki',
  saleAmt: 'Kiasi cha Uzo',
  whtRate: 'Kiwango WHT',
  whtAmt: 'Kiasi WHT',
  whtFromSales: 'WHT Tuliyokusanya (Mauzo)',
  whtFromPurchases: 'WHT Tuliyolipa (Manunuzi)',
  purchaseAmt: 'Kiasi cha Ununuzi',
  totalWHTCharged: 'Jumla ya WHT Tuliyolipa',

  // VAT Report labels
  vatReport: 'Ripoti ya VAT',
  vatReportFull: 'Ripoti ya VAT (Kodi ya Ongezeko la Thamani)',
  totalVATFromSales: 'Jumla ya VAT (Mauzo)',
  totalVATFromPurchases: 'Jumla ya VAT (Manunuzi)',
  noVATTransactions: 'Hakuna miamala ya VAT katika kipindi hiki',
  vatFromSales: 'VAT Tuliyokusanya (Mauzo)',
  vatFromPurchases: 'VAT Tuliyolipa (Manunuzi)',
  vatRate: 'Kiwango VAT',
  vatAmt: 'Kiasi VAT',

  // Common report labels
  fromLabel: 'Kuanzia',
  toLabel: 'Mpaka',
  invoice: 'Ankara',
  item: 'Bidhaa',

  // Stock Adjustment
  stockAdjustment: 'Marekebisho ya Stock',

  // Tax labels
  addTax: '+ Ongeza Kodi',
  vatOption: 'VAT (Kodi ya Ongezeko la Thamani)',
  withholdingOption: 'Kodi ya Zuio (Withholding Tax)',
  noTaxesAdded: 'Hakuna kodi zilizoongezwa. Bonyeza "Ongeza Kodi" kuongeza VAT 18% au kodi ya kawaida.',

  // User Manual
  userManual: 'Mwongozo wa Kutumia',
  userManualSub: 'Mwongozo wa kutumia Biashara Track App (PDF)',

  // FAQ
  faq: 'Maswali ya Kawaida',

  // Returns
  salesReturns: 'Marejesho ya Mauzo',
  purchaseReturns: 'Marejesho ya Manunuzi',

  // Missing keys (used in App.js with || fallbacks)
  download: 'Pakua',
  search: 'Tafuta',
  newestFirst: 'Mpya Kwanza',
  oldestFirst: 'Zamani Kwanza',
  highestAmount: 'Kiasi Kikubwa',
  lowestAmount: 'Kiasi Kidogo',
  noResults: 'Hakuna Matokeo',
  invoiceItems: 'Vitu vya Ankara',
  viewItems: 'Tazama Vitu',
  sale: 'Uuzaji',
  purchase: 'Ununuzi',
  expense: 'Gharama',
  unit: 'Kipimo cha Bidhaa',
  buyingPrice: 'Bei ya Kununua',
  yesterday: 'Jana',
  lastWeek: 'Wiki Iliyopita',
  lastMonth: 'Mwezi Uliopita',

  // VAT & P&L
  vatRateSetting: 'Kiwango cha VAT',
  profitAndLoss: 'Faida na Hasara',

  // Ledger
  ledger: 'Daftari',
  customerLedger: 'Daftari la Mteja',
  supplierLedger: 'Daftari la Muuzaji',
  outstanding: 'INADAIWA',
  owedToSupplier: 'UNADAIWA',
  markPaid: 'Weka Limelipwa',
  noTransactionsYet: 'Hakuna miamala bado',
  totalTransactions: 'MIAMALA',
  lastYear: 'Mwaka Uliopita',
  // Ufikivu (Accessibility)
  skipToContent: 'Ruka hadi maudhui kuu',
  mainNavigation: 'Urambazaji mkuu',
  loadingApp: 'Inapakia Biashara Track...',
  loading: 'Inapakia',
};

export default sw;
